import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  updateGroupPayload: {}
}

export const updateProjectSlice = createSlice({
  name: 'updateProject',
  initialState,
  reducers: {
    setUpdateGroupPayload: (state, action) => {
      state.updateGroupPayload = action.payload
    },
    resetUpdateGroupPayload: (state) => {
      state.updateGroupPayload = {}
    },
    resetUpdateProject: () => initialState
  }
})

export const {setUpdateGroupPayload, resetUpdateGroupPayload, resetUpdateProject} = updateProjectSlice.actions

// Selectors
export const selectUpdateGroupPayload = (state) => state.updateProject.updateGroupPayload

export default updateProjectSlice.reducer
